export const hero = {
  it: {
    greeting: "La tua azienda è un'eccellenza.",
    name: "Il tuo sito web non dovrebbe essere un reperto archeologico.",
    title: "Mentre tu produci qualità, il tuo vecchio sito ti sta facendo perdere opportunità. Trasformiamo la tua presenza digitale in uno strumento che lavora al tuo fianco. 24/7.",
    roles: [],
    ctaContact: "Parla con l'Analista AI",
    ctaAbout: "Scopri la Strategia",
    socialProof: "Già scelto da aziende a Ravenna"
  },
  en: {
    greeting: "Your company is excellent.",
    name: "Your website shouldn't be an archaeological artifact.",
    title: "While you produce quality, your old site is losing you opportunities. Let's transform your digital presence into a tool that works by your side. 24/7.",
    roles: [],
    ctaContact: "Talk to AI Analyst",
    ctaAbout: "Discover Strategy",
    socialProof: "Already chosen by companies in Ravenna"
  }
};
